import { Alert } from "@productlane/ui"

import { useTrial } from "@/lib/useTrial"
import { SettingsContainer } from "@/screens/settings/settings-switches/settings-container"
import { SettingsHeader } from "../../settings-header"
import { ContactsCsvUploadWizard } from "./steps/contacts-csv-upload-wizard"

export function ContactsCsvImportPage() {
	const { hasTrialEnded } = useTrial()

	if (hasTrialEnded) {
		return (
			<>
				<SettingsHeader title="Contacts CSV import" subtitle={null} />
				<Alert variant="warning">Trial ended. Upgrade to import data.</Alert>
			</>
		)
	}

	return (
		<>
			<SettingsHeader title="Contacts CSV import" subtitle={null} />
			<SettingsContainer>
				<ContactsCsvUploadWizard />
			</SettingsContainer>
		</>
	)
}
